"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var qs_1 = require("qs");
var isNode_1 = __importDefault(require("./utils/isNode"));
var getNodeVersion_1 = __importDefault(require("./utils/getNodeVersion"));
var Error_1 = __importDefault(require("./utils/Error"));
var throttle_1 = __importDefault(require("./throttle"));
function createHttpClient(_a) {
  var axios = _a.axios,
    options = _a.options;
  var defaultConfig = {
    insecure: false,
    retryOnError: true,
    // Passed to axios
    headers: {
      'Content-Type': '',
      'X-CB-Api-Key': ''
    },
    httpAgent: false,
    httpsAgent: false,
    proxy: false,
    basePath: '',
    maxContentLength: 1073741824,
    throttle: 1,
    interval: 1000
  };
  var config = __assign(__assign({}, defaultConfig), options);
  if (!config.apiKey) {
    throw new TypeError('Expected parameter apiKey');
  }
  if (!config.apiUrl) {
    throw new TypeError('Expected parameter apiUrl');
  }
  config.headers['X-CB-Api-Key'] = options.apiKey;
  config.headers['Content-Type'] = 'application/vnd.cb-headless.v1+json';
  if (isNode_1.default()) {
    // @ts-ignore
    config.headers['user-agent'] = 'node.js/' + getNodeVersion_1.default();
    // @ts-ignore
    config.headers['Accept-Encoding'] = 'gzip';
  }
  var axiosOptions = {
    // Axios
    baseURL: options.apiUrl + "/api/v1/" + (options.preview ? 'preview' : 'published'),
    headers: config.headers,
    httpAgent: config.httpAgent,
    httpsAgent: config.httpsAgent,
    paramsSerializer: qs_1.stringify,
    maxContentLength: config.maxContentLength
  };
  var axiosInstance = axios.create(axiosOptions);
  axiosInstance.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    var _a, _b, _c;
    var url = error.config.baseURL + "/" + error.config.url + (error.config.params.isoCode ? '?' + new URLSearchParams(error.config.params).toString() : '');
    return Promise.reject(new Error_1.default({
      name: error.name,
      message: error.message,
      status: (_a = error.response) === null || _a === void 0 ? void 0 : _a.status,
      url: url,
      locale: (_b = error.config.params) === null || _b === void 0 ? void 0 : _b.isoCode,
      code: (_c = error.response) === null || _c === void 0 ? void 0 : _c.status,
      originalError: error
    }));
  });
  if (config.throttle > 0 && config.interval > 0) {
    console.log("[cb-sdk] Throttling requests at " + config.throttle + " request(s) every " + config.interval + "ms");
    throttle_1.default(axiosInstance, config.throttle, config.interval);
  }
  return axiosInstance;
}
exports.default = createHttpClient;